/* ============================================================
   GOB — header search field
   Extracted 2026-08-25 from sections/gob-header-style.liquid.

   7.3 KB of logic that used to be inline in the section, so it was
   re-downloaded and re-parsed on every page view and could never be cached.
   The two merchant-editable strings stay inline as window.GOB_HEADER_SEARCH,
   because an asset file cannot render Liquid; everything else lives here.

   Behaviour is unchanged. The block already ran build() immediately when the
   document was past 'loading', which is exactly the state a deferred script
   sees, and it also rebuilds on shopify:section:load and window load.
   ============================================================ */
(function(){
  /* Settings arrive from the small inline block in the section — an asset
     file cannot render Liquid. Defaults keep the field usable if that block
     is ever missing. */
  var CFG         = window.GOB_HEADER_SEARCH || {};
  var PLACEHOLDER = CFG.placeholder || 'Search';
  var ALL_LABEL   = CFG.allLabel    || 'See all results';
  var FETCH = 10, SHOW = 6;

  /* ---------- relevance ---------------------------------------------
     Shopify returns suggestions in its own order and gives no way to
     weight one field above another. Nine "Display Wall-Mount for ..."
     products carry every set number inside the search index — residue
     from being duplicated from one another, and present in no editable
     field — so a query like 42083 comes back with mounts for other sets
     above the real ones.

     Reorder here: a title match beats a tag or SKU match, and inside a
     title match the order is the one a visitor wants — the light kit
     they came for, then the display mount for that set, then the LED
     nameplate. Stable within each tier, so Shopify's own order survives
     wherever this has no opinion.                                     */
  function norm(s){
    return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
  }
  function tierOf(t){
    if (t.indexOf('light kit') > -1) return 0.6;
    if (t.indexOf('wall mount') > -1 || t.indexOf('display') > -1) return 0.4;
    if (t.indexOf('nameplate') > -1) return 0.2;
    return 0;
  }
  /* a bare set number, with or without a range: 42083, 77242-77251 */
  function setNumber(q){
    var t = String(q || '').trim();
    return /^[0-9]{4,7}([-\s][0-9]{4,7})?$/.test(t) ? t : null;
  }
  function rank(products, q){
    var needle = norm(q);
    if (!needle) return products;
    var tight = needle.replace(/ /g,'');
    var words = needle.split(' ').filter(Boolean);
    function score(p){
      var t = norm(p.title), s = 0;
      if (t.indexOf(needle) > -1 || t.replace(/ /g,'').indexOf(tight) > -1) s = 2;
      else if (words.length > 1 && words.every(function(w){ return t.indexOf(w) > -1; })) s = 1;
      return s ? s + tierOf(t) : 0;
    }
    return products
      .map(function(p,i){ return { p:p, s:score(p), i:i }; })
      .sort(function(a,b){ return (b.s - a.s) || (a.i - b.i); })
      .map(function(x){ return x.p; });
  }

  function build(){
    var layout = document.querySelector('.header-layout');
    if (!layout || layout.querySelector('.gobhs')) return;
    var icons = layout.querySelector('.header-item--icons');
    if (!icons) return;

    var wrap = document.createElement('div');
    wrap.className = 'gobhs';
    wrap.innerHTML =
      '<form class="gobhs__form" action="/search" method="get" role="search">' +
        '<input type="hidden" name="type" value="product">' +
        '<span class="gobhs__ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
          'stroke-width="1.6" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle>' +
          '<path d="m20 20-3.6-3.6"></path></svg></span>' +
        '<input class="gobhs__in" type="search" name="q" autocomplete="off" ' +
          'placeholder="' + PLACEHOLDER.replace(/"/g,'&quot;') + '" aria-label="Search">' +
      '</form>' +
      '<div class="gobhs__panel" role="listbox"></div>';
    layout.insertBefore(wrap, icons);

    var input = wrap.querySelector('.gobhs__in');
    var panel = wrap.querySelector('.gobhs__panel');
    var timer = null, lastQ = '';

    function close(){ panel.setAttribute('data-open','0'); panel.innerHTML = ''; }

    function render(items, q){
      if (!items.length){
        panel.innerHTML = '<div class="gobhs__empty">No kit found for &ldquo;' +
          q.replace(/[<>&]/g,'') + '&rdquo;</div>';
      } else {
        panel.innerHTML = items.map(function(p){
          var img = p.featured_image && p.featured_image.url
            ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '';
          return '<a class="gobhs__row" href="' + p.url + '">' + img +
                 '<span class="gobhs__t">' + p.title + '</span></a>';
        }).join('') +
        '<a class="gobhs__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">' +
        ALL_LABEL + '</a>';
      }
      panel.setAttribute('data-open','1');
    }

    function suggest(term){
      return fetch('/search/suggest.json?q=' + encodeURIComponent(term) +
            '&resources[type]=product&resources[limit]=' + FETCH +
            '&resources[options][unavailable_products]=last' +
            '&resources[options][fields]=title,product_type,variants.title,variants.sku,tag')
        .then(function(r){ return r.json(); })
        .then(function(d){
          return (d.resources && d.resources.results && d.resources.results.products) || [];
        });
    }
    /* Shopify clamps resources[limit] to 10 and silently ignores anything
       higher. For a set number the nine polluted wall-mounts plus the real
       light kit fill that entire response, so the LED nameplate for the set
       never arrives. Ask a second time with " display" appended, which does
       reach it, and merge in anything for the same set the first call could
       not fit. Dedupe on the product id: suggest.json stamps per-query
       tracking params onto the url, so the same product comes back with a
       different url from each call. */
    function lookup(q){
      var num = setNumber(q);
      var calls = [suggest(q)];
      if (num) calls.push(suggest(q + ' display').catch(function(){ return []; }));

      Promise.all(calls)
        .then(function(sets){
          if (input.value.trim() !== q) return;
          var prods = sets[0].slice();
          if (sets[1] && sets[1].length){
            var tight = norm(num).replace(/ /g,'');
            var key = function(p){ return String(p.id || p.handle || p.title); };
            var seen = {};
            prods.forEach(function(p){ seen[key(p)] = 1; });
            sets[1].forEach(function(p){
              if (seen[key(p)]) return;
              if (norm(p.title).replace(/ /g,'').indexOf(tight) === -1) return;   /* same set only */
              seen[key(p)] = 1;
              prods.push(p);
            });
          }
          render(rank(prods, q).slice(0, SHOW), q);
        })
        .catch(function(){ close(); });
    }

    input.addEventListener('input', function(){
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2){ close(); lastQ = ''; return; }
      if (q === lastQ) return;
      lastQ = q;
      timer = setTimeout(function(){ lookup(q); }, 180);
    });

    input.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
    document.addEventListener('click', function(e){ if (!wrap.contains(e.target)) close(); });
  }

  function syncMegaWidth(){
    var pw = document.querySelector('.site-header .page-width');
    if (!pw) return;
    var r = pw.getBoundingClientRect();
    document.querySelectorAll('.megamenu__wrapper').forEach(function(w){
      w.style.setProperty('--gobhs-page', Math.round(r.width) + 'px');
      w.style.paddingLeft  = getComputedStyle(pw).paddingLeft;
      w.style.paddingRight = getComputedStyle(pw).paddingRight;
    });
  }
  window.addEventListener('resize', syncMegaWidth);
  document.addEventListener('shopify:section:load', syncMegaWidth);
  setTimeout(syncMegaWidth, 0);
  window.addEventListener('load', syncMegaWidth);

  if (document.readyState !== 'loading') build();
  else document.addEventListener('DOMContentLoaded', build);
  document.addEventListener('shopify:section:load', build);
  window.addEventListener('load', build);
})();
